export default "__VITE_ASSET__BZt7D_h9__"